<template>
    <div class="">
        <div class="tab-content p-2 text-center" v-if="!isLoaded">
            {{ $t('loading') }}
        </div>
        <div v-else>
            <div class="mx-auto col-lg-4 col-md-6 col-sm-12 header-margin">
                <div class="text-center p-2">
                    <h3>AUBE</h3>
                    <p>{{ $t('aube_quest.connect.title') }}</p>
                </div>
                <div class="info-box">
                    <small class="text-muted">{{ $t('aube_quest.connect.quest_information') }}</small>
                    <div>Quest ID: {{ formData.questId }}</div>
                    <div>Connector ID: {{ formData.connectorMemberId }}</div>
                    <div>{{ $t('aube_quest.connector_start_date') }}: {{ formData.joinedDate }}</div>
                    <div class="text-danger pre">{{ errors.questId ? $t('aube_quest.verify_error.' + errors.questId) : '' }}</div>
                </div>
                <p class="text-center mt-5 mb-5">{{ $t('aube_quest.connect.chose_cooperation_method') }}</p>
                <div class="mb-3 p-3 border rounded">
                    <h6>{{ $t('aube_quest.connect.signup_connect') }}</h6>
                    <p class="mb-3 pre">{{ $t('aube_quest.connect.if_do_not_have_account') }}</p>
                    <button
                        class="btn btn-primary btn-block"
                        @click="handleRegistrationButton"
                        :class="!!errors.questConnected ? 'cursor-not-allowed btn-disable text-white' : ''"
                        :disabled="!!errors.questConnected"
                    >
                        {{ $t('aube_quest.connect.registration') }}
                    </button>
                    <!--                <div class="mt-2 text-danger pre">{{ errors.questConnected ? $t('aube_quest.verify_error.' + errors.questConnected) : '' }}</div>-->
                </div>
                <div class="note text-center">
                    {{ $t('aube_quest.connect.quest_do_not_provide_email') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QuestService from '../../../services/QuestService';
import AuthUtil from '../../../utils/AuthUtil';
import UserService from "../../../services/UserService";

export default {
    name: 'connect-module',
    created() {
        const token = this.$route.query.token;
        if (token) {
            this.formData.token = token;
            localStorage.setItem('token', token);
            this.checkToken();
        }
    },
    data() {
        return {
            errors: this.getDefaultFields(),
            formData: this.getDefaultFields(),
            submitted: false,
            isLoaded: false,
            isValidToken: {
                verified: false,
            }
        }
    },
    methods: {
        getDefaultFields() {
            return {
                token: '',
                login: '',
                questId: '',
                connectorMemberId: '',
                joinedDate: '',
                questConnected: '',
            };
        },
        async checkToken() {
            if (this.formData.token !== '') {
                try {
                    const result = await QuestService.verifyToken(this.formData);
                    if (!result.data.exists) {
                        this.errors.questId = 'quest_id_invalid';
                        this.isLoaded = true;
                        return;
                    }
                    localStorage.setItem('questId', result.data.quest_id);
                    this.formData.questId = result.data.quest_id;
                    this.formData.connectorMemberId = result.data.connector_id;
                    this.formData.joinedDate = result.data.joined_date;
                    await this.checkQuestConnectedStatus();
                } catch (e) {
                    const error = e.response;
                    console.log(e, '123')
                    this.errors.questId = error.data.message;
                } finally {
                    this.isLoaded = true;
                }
            } else {
                this.isLoaded = true;
                this.errors.questId = 'quest_id_invalid';
            }

        },
        async checkQuestConnectedStatus() {
            if (this.formData.questId !== '') {
                try {
                    const result = await QuestService.getQuestConnectStatus(this.formData.questId);
                    if (result.data) {
                        this.errors.questConnected = 'QUEST_CONNECTED';
                    }
                    console.log(result.data);
                } catch (e) {
                    this.errors.questConnected = 'QUEST_CONNECTED';
                } finally {
                    this.isLoaded = true;
                }
            } else {
                this.isLoaded = true;
                this.errors.questId = 'QUEST_CONNECTED';
            }

        },
        async handleLoginButton() {
            if (this.errors.questId || !this.errors.questConnected) {
                return;
            }
            const isLogin = AuthUtil.isAuth();
            if (isLogin) {
                await this.$router.push('/');
            } else {
                await this.$router.push('/login');
            }
        },
        async handleRegistrationButton() {
            if (!!this.errors.questConnected) {
                return false;
            }
            const isLogin = AuthUtil.isAuth();
            if (isLogin) {
                await UserService.revokeToken(AuthUtil.getAuthToken());
                AuthUtil.clearAuth();
            }
            const questId = this.formData.questId;
            if (questId) {
                this.$router.push({path: '/registration-quest'});
            } else {
                this.errors.questId = 'quest_id_invalid';
            }
        }
    }
}
</script>

<style scoped>

.box-area p {
    margin-top: 2px;
    margin-bottom: 2px;
    padding-top: 1px;
}

/*ボタンのスタイル*/
.btn-primary {
    background: #451493 !important;
    border-color: #451493 !important;
}

.btn-disable {
    background-color: #c6c6c6 !important;
    border-color: #c6c6c6 !important;
}

.btn-disable:hover,
.btn-disable:focus,
.btn-disable {
    background-color: #c6c6c6 !important;
    border-color: #c6c6c6 !important;
}

.btn-disable:hover,
.btn-disable:focus {
    color: #fff !important;
    background-color: #c6c6c6 !important;
    border-color: #c6c6c6 !important;
    box-shadow: none !important;
    background-color: #c6c6c6 !important;
    border-color: #c6c6c6 !important;
    box-shadow: none !important;
}

.info-box {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
}

.note {
    font-size: 0.9rem;
    color: #6c757d;
    margin-top: 15px;
}

.pre {
    white-space: pre-wrap;
}

.cursor-not-allowed {
    cursor: not-allowed;
}

/*スマホ用css*/
@media screen and (max-width: 479px) {
    .header-margin {
        padding-left: 0px;
        padding-right: 0px;
    }
}
</style>
